import { Route } from '/@/modules/core/app/constants/api.constants';
import { BaseAsyncResource } from '@/modules/core/app/resources/BaseAsyncResource';
import { AskClaraQuestionResponseObject } from '@/modules/ai/models/AskClaraQuestionResponseObject';

export class ClaraAsyncResource extends BaseAsyncResource {
  async askQuestion(params: Params = {}): Promise<AskClaraQuestionResponseObject> {
    return this.postData(
      Route.AI_CLARA_ASKQUESTION,
      params
    ) as Promise<AskClaraQuestionResponseObject>;
  }
}

export default new ClaraAsyncResource();
